/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ResolverOptionsType } from './ResolverOptionsType';

/**
 * Constructor.
 * @class
 * @author eric.wittmann@gmail.com
 */
export class ResolverOptions {
    public static of(...options : ResolverOptionsType[]) : ResolverOptions {
        let rval : ResolverOptions = new ResolverOptions();
        if(options != null) {
            for(let index196=0; index196 < options.length; index196++) {
                let option = options[index196];
                {
                    rval.add(option);
                }
            }
        }
        return rval;
    }

    /*private*/ options : Array<ResolverOptionsType> = <any>([]);

    public constructor() {
    }

    public add(option : ResolverOptionsType) {
        /* add */((s, e) => { if(s.indexOf(e)==-1) { s.push(e); return true; } else { return false; } })(this.options, option);
    }

    public contains(option : ResolverOptionsType) : boolean {
        return /* contains */(this.options.indexOf(<any>(option)) >= 0);
    }
}
ResolverOptions["__class"] = "io.apicurio.datamodels.core.util.ResolverOptions";



